import { render, staticRenderFns } from "./RouteParams.vue?vue&type=template&id=65fecdc5"
import script from "./RouteParams.vue?vue&type=script&lang=js"
export * from "./RouteParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports